import { Injector } from '@angular/core';
import { Store } from '@sama/app-state';
import { assert } from '@sama/js-core';
import { ShapeState2D } from '../../../../cross-team-shared/annotation/shared/state/shape-state';
import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';
import {
  SLIDER_INDEX,
  SliderRectangleHelper,
} from '../../shape-helpers/slider-rectangle-helper';
import { AbstractVectorTranslationHelper } from '../../tools/shared/drag-handlers/abstract-vector-translation-helper';

export class SliderTranslationHelper extends AbstractVectorTranslationHelper {
  protected override method = 'drag_slider';
  protected clickedShapeStore?: Store<ShapeState2D>;

  constructor(injector: Injector, shapeStore?: Store<ShapeState2D>) {
    super(injector);
    this.clickedShapeStore = shapeStore;
  }

  override getCandidateShapeStores() {
    if (this.clickedShapeStore) {
      return [this.clickedShapeStore];
    }

    const shapeStores = super.getCandidateShapeStores();

    assert(
      shapeStores.every(
        (shapeStore) => shapeStore.state().type === 'slider_rectangle',
      ),
      'Only slider rectangles are allowed when using SliderTranslationHelper',
    );

    return shapeStores;
  }

  protected getMovableSubpointIndexes() {
    return [SLIDER_INDEX];
  }

  protected override fixPoints(newPoints: Point2D[]) {
    const helper = new SliderRectangleHelper();
    return helper.fixPoints(newPoints, undefined);
  }
}
